import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import "./KindleSlides.css"

import { checkItemExists, tellMeMore } from "../script";

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faChevronLeft, faChevronRight, faAnglesDown, faEllipsis} from '@fortawesome/free-solid-svg-icons';

export default function KindleSlides(props) {
    const navigate = useNavigate();
    const urlParams = new URLSearchParams(useLocation().search);

    const [pageIndex, setPageIndex] = useState(0);
    const [showAllPages, setShowAllPages] = useState(false);
    const [showHeader, setShowHeader] = useState(false);

    const lastGuid = urlParams.get('last');
    const lastIndex = urlParams.get('index');

    let mouseX = 0;

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip">
            {props}
        </Tooltip>
    );

    useEffect(() => {
        // If we are returning to the previous page, make sure to start at the correct response
        if (lastIndex && !lastGuid) {
            setPageIndex(parseInt(lastIndex));
        }

    }, []);


    // Swipe handlers
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => goToNextPage(),
        onSwipedRight: () => goToPreviousPage(),
        onSwipedDown: () => doTellMeMore(),
        onSwipedUp: () => doNavigateBack(),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    const goToNextPage = () => {
        if (pageIndex < props.slides.length - 1) {
            setPageIndex((prevIndex) => prevIndex + 1); // Move to the next page
        }
    };

    const goToPreviousPage = () => {
        if (pageIndex > 0) {
            setPageIndex((prevIndex) => prevIndex - 1); // Move to the previous page
        }
    };

    const doTellMeMore = () => {
        if (props.useExtraControls && !(lastGuid) && pageIndex > 0) {
            tellMeMoreOnClick();
        }
    }

    const doNavigateBack = () => {
        if (props.useExtraControls && lastGuid) {
            navigate(`/?item=${lastGuid}&index=${lastIndex}`, { replace: true });
            window.location.reload();
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "ArrowRight") {
            goToNextPage();
        } else if (e.key === "ArrowLeft") {
            goToPreviousPage();
        } else if (e.key === "ArrowDown") {
            doTellMeMore();
        } else if (e.key === "ArrowUp") {
            doNavigateBack();
        }
    };

    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [pageIndex]);

    function handleTap() {
        if (!showAllPages) {
            let width = document.getElementById("response-slides").offsetWidth;
            if (mouseX < width / 3) {
                goToPreviousPage();
                return;
            } else if (mouseX > 2 * width / 3) {
                goToNextPage();
                return;
            }
        }
        setShowAllPages(!showAllPages);
        setShowHeader(!showHeader);
    };

    function recordMouseX(event) {
        mouseX = event.clientX;
    }

    const handlePageClick = (index) => {
        setPageIndex(index);
        setShowAllPages(false);
        setShowHeader(false);
    };


    const text_max_length = 35;
    function getShortenedHeader(text) {
        if (text.length < text_max_length) {
            return text;
        } else {
            // Not a clever way of doing this, should probably do it smartly at some point
            while (text.length > text_max_length) {
                text = text.substring(0, text.lastIndexOf(" "));
            }
            return text + "..."
        }
    }

    async function tellMeMoreOnClick() {
        const query = props.slides[pageIndex] + " Tell me more";
        const NAMESPACE_URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8'; // UUIDv5 Namespace URL
        /*global uuid*/
        const guid = uuid.v5(query, NAMESPACE_URL);

        if (query !== '') {
            document.getElementById('spinner-overlay').style.display = 'flex';
            const encodedQuery = encodeURIComponent(query);

            const itemExists = await checkItemExists(guid);
            if (itemExists) {
                navigate(`/?item=${guid}&last=${props.guid}&index=${pageIndex}`, { replace: true });
                window.location.reload();
            } else {
                await tellMeMore(encodedQuery, props.guid, pageIndex, document.getElementById('loading'), document.getElementById('spinner-overlay'), navigate);
            }
        }
    }

    return (
        <>
            <div className="reveal" id="response-slides" {...swipeHandlers} onClick={handleTap} onMouseDown={recordMouseX}>
                {showAllPages ? (
                    <>
                        <div className="all-pages">
                            {props.slides.map((text, index) => {
                                return <div className={"slide-content page-thumbnail" + ((pageIndex == index) ? " active-page" : "")}
                                    key={index}
                                    onClick={() => handlePageClick(index)}>
                                    <h2 className="page-thumbnail-text">{getShortenedHeader(text.split(':')[0].replace(/\*/g, '').trim())}</h2>
                                </div>
                            })}
                        </div>
                        {/* Padding div, lets the user scroll down */}
                        <div style={{ height: "30vh" }} />
                    </>
                ) : (
                    <>
                        <div className="page">
                            <div style={{ marginTop: "55px", marginBottom: "auto" }}>
                                <h2 className="page-header-text">{props.slides[pageIndex].split(':')[0].replace(/\*/g, '').trim()}</h2>
                                <div style={{ height: "20px" }} />
                                <p className="page-content-text" dangerouslySetInnerHTML={{ __html: props.slides[pageIndex].split(':')[1].trim() }}></p>
                            </div>
                        </div>
                        {/* Slide controls */}
                        {pageIndex > 0 ?
                            <FontAwesomeIcon size="xl" className={"left-arrow hide-on-mobile " + (props.useExtraControls && !(lastGuid) ? "raised " : "") + (props.useExtraControls ? "left-arrow-shifted" : "")} icon={faChevronLeft} onClick={(event) => {
                                event.stopPropagation();
                                goToPreviousPage()
                            }} /> : null}
                        {pageIndex < props.slides.length - 1 ?
                            <FontAwesomeIcon size="xl" className={"right-arrow hide-on-mobile " + (props.useExtraControls && !(lastGuid) ? "raised" : "")} icon={faChevronRight} onClick={(event) => {
                                event.stopPropagation();
                                goToNextPage()
                            }} /> : null}
                        {props.useExtraControls && !(lastGuid) && pageIndex > 0 ?
                            <FontAwesomeIcon size="xl" className="down-arrow" icon={faChevronDown} onClick={(event) => {
                                event.stopPropagation();
                                tellMeMoreOnClick()
                            }} /> : null
                        }
                        {props.useExtraControls && lastGuid ?
                            <FontAwesomeIcon size="xl" className="up-arrow" icon={faChevronUp} onClick={(event) => {
                                event.stopPropagation();
                                navigate(`/?item=${lastGuid}&index=${lastIndex}`, { replace: true });
                                window.location.reload();
                            }} /> : null
                        }
                    </>
                )}
            </div>
            {props.allowInstant ?
                <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip("Generate a list of further queries from the current content")}
                >
                    < button className="fixed-button upper-button-3" id="btn-dig-deeper" onClick={() => { navigate("/more?title=" + props.slides[pageIndex].split(':')[0].replace(/\*/g, '').trim() + "&keywords=" + props.slides[pageIndex].split(':')[1].trim() + "&last=" + props.guid + "&index=" + pageIndex) }}>
                        <FontAwesomeIcon icon={faEllipsis} />
                    </button >
                </OverlayTrigger> : null
            }

            {/* Page numbers */}
            {!showAllPages ? (
                <div className="page-number"><h5>{(pageIndex + 1) + "/" + props.slides.length}</h5></div>) : null}
        </>
    );
}